<template>
    <div class="content">
        <div class="navigation">
            <b-navbar toggleable="md" type="light" variant="light">
                <b-navbar-brand>
                    <a href="#willkommen" v-smooth-scroll="{ offset: -60 }">
                        <img src="../assets/logo-text-only.png" height=50 alt="Logo">
                    </a>
                </b-navbar-brand>
                <b-navbar-toggle target="nav-collapse-top"></b-navbar-toggle>

                <b-collapse id="nav-collapse-top" is-nav>
                    <b-navbar-nav class="ml-auto">
                        <a class="nav-item nav-link" href="#kontakt"
                           v-smooth-scroll="{ offset: firstOffset }">Kontakt</a>
                        <a class="nav-item nav-link" href="#uebermich" v-smooth-scroll="{ offset: offset }">Über
                            mich</a>
                        <a class="nav-item nav-link" href="#arbeitsweise" v-smooth-scroll="{ offset: offset }">Arbeitsweise</a>
                        <a class="nav-item nav-link" href="#anmeldung"
                           v-smooth-scroll="{ offset: offset }">Anmeldung</a>
                        <a class="nav-item nav-link" href="#corona" v-smooth-scroll="{ offset: offset }">Corona</a>
                    </b-navbar-nav>
                </b-collapse>
            </b-navbar>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'PMenu',
        data() {
            return {
                offset: -75,
                firstOffset: -60
            }
        },
        methods: {}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .content {
        background-color: #f8f9fa;
        display: flex;
        justify-content: space-between;
        box-shadow: 0 6px 10px -6px black;
        margin-bottom: 10px;
    }

    .logo img {
        height: 60px;
    }

    .navigation {
        width: 100%;
    }

    .navigation .nav-item {
        font-size: 1.2em;
    }
</style>
